import { call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { gcApi } from '../config/axios';
import { isReadonlyMode } from 'system/SystemUtil';

import {
    FETCH_MFP_LINK_STATUS,
    FETCH_MFP_LINK_STATUS_SUCCESS,
    FETCH_MFP_LINK_STATUS_FAIL
} from '../actions/mfpActions.js';
import {
    AUTHORIZE_MFP,
    AUTHORIZE_MFP_FAIL,
    AUTHORIZE_MFP_SUCCESS,
    DISCONNECT_FROM_MFP,
    FETCH_MERGED_SUMMARY,
    FETCH_MFP,
    FETCH_MFP_FAIL,
    FETCH_MFP_INFO,
    FETCH_MFP_INFO_FAIL,
    FETCH_MFP_INFO_SUCCESS,
    FETCH_MFP_LAST_SYNC,
    FETCH_MFP_LAST_SYNC_FAIL,
    FETCH_MFP_LAST_SYNC_SUCCESS,
    FETCH_MFP_RECENT_CALORIES_GOAL,
    FETCH_MFP_RECENT_CALORIES_GOAL_DONE,
    FETCH_MFP_SUCCESS,
    SYNC_MFP_NOW,
    SYNC_MFP_NOW_FAIL,
    SYNC_MFP_NOW_SUCCESS,
    UPDATE_CALORIES_VIEW_STATE
} from 'actions/ActionTypes';
import { ViewStates } from 'reducers/dailySummary/dailyCalories';
import { fetchMFPAccountInfo } from 'reducers/mfp/mfp';

export function* fetchMFPLinkStatusSaga() {
    let url = '/myfitnesspal-service/userAuthorization';

    if (isReadonlyMode()) {
        url = '/myfitnesspal-service/accountInformation';
    }

    try {
        const response = yield call(gcApi.get, url);

        yield put({
            type: FETCH_MFP_LINK_STATUS_SUCCESS,
            mfpLinkStatus: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_MFP_LINK_STATUS_FAIL,
            mfpLinkStatus: {}
        });
    }
}

export function* authorizeMyFitnessPal(action) {
    try {
        const response = yield call(gcApi.post, `/myfitnesspal-service/userAuthorization/`, {
            authorizationCode: action.authorizationCode
        });

        yield put({
            type: AUTHORIZE_MFP_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: AUTHORIZE_MFP_FAIL,
            data: {}
        });
    }
}

export function* fetchMFPSaga() {
    try {
        const response = yield call(gcApi.get, '/partner-service/partner/consumer/MY_FITNESS_PAL');

        yield put({
            type: FETCH_MFP_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_MFP_FAIL,
            data: {}
        });
    }
}

export function* disconnectFromMFP(action) {
    try {
        const response = yield call(gcApi.delete, `/myfitnesspal-service/userAuthorization`, action.mfpAuthorization);

        yield put({
            type: FETCH_MFP_SUCCESS,
            data: response.data
        });

        yield put({
            type: FETCH_MFP_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_MFP_FAIL,
            data: {}
        });
    }
}

export function* fetchMFPUserInfo() {
    try {
        const response = yield call(gcApi.get, '/myfitnesspal-service/fetchUserInfo');

        yield put({
            type: FETCH_MFP_INFO_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_MFP_INFO_FAIL,
            data: {}
        });
    }
}

export function* fetchMfpLastSync() {
    try {
        const response = yield call(gcApi.get, '/myfitnesspal-service/lastSync');

        yield put({
            type: FETCH_MFP_LAST_SYNC_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_MFP_LAST_SYNC_FAIL,
            data: {}
        });
    }
}

export function* fetchMfpRecentCaloriesGoalSaga() {
    try {
        const response = yield call(gcApi.get, `/myfitnesspal-service/recentCalorieGoal`);
        yield put({
            type: FETCH_MFP_RECENT_CALORIES_GOAL_DONE,
            data: response.data
        });
    } catch (error) {
        yield put({
            type: FETCH_MFP_RECENT_CALORIES_GOAL_DONE,
            error: true,
            data: null
        });
    }
}

export function* syncNow(action) {
    try {
        const response = yield call(gcApi.post, `/myfitnesspal-service/syncData/${action.calendarDate}`, {
            calendarDate: action.calendarDate
        });

        yield put({
            type: SYNC_MFP_NOW_SUCCESS,
            data: response.data
        });

        yield put({
            type: FETCH_MERGED_SUMMARY,
            displayName: action.displayName,
            calendarDate: action.calendarDate,
            meta: {
                cacheTime: null
            }
        });
        yield put(fetchMFPAccountInfo());
        yield fork(fetchMfpRecentCaloriesGoalSaga);
    } catch (e) {
        yield put({
            type: SYNC_MFP_NOW_FAIL,
            data: {}
        });

        yield put({
            type: UPDATE_CALORIES_VIEW_STATE,
            state: ViewStates.UNABLE_TO_CONNECT
        });
    }
}

export const mfpSagas = [
    takeEvery(FETCH_MFP_LINK_STATUS, fetchMFPLinkStatusSaga),
    takeEvery(AUTHORIZE_MFP, authorizeMyFitnessPal),
    takeEvery(FETCH_MFP, fetchMFPSaga),
    takeEvery(FETCH_MFP_INFO, fetchMFPUserInfo),
    takeEvery(DISCONNECT_FROM_MFP, disconnectFromMFP),
    takeEvery(FETCH_MFP_LAST_SYNC, fetchMfpLastSync),
    takeEvery(SYNC_MFP_NOW, syncNow),
    takeLatest(FETCH_MFP_RECENT_CALORIES_GOAL, fetchMfpRecentCaloriesGoalSaga)
];
